<style scoped>
</style>

<template>
  <div class="vue-box">
    <div class="c-panel">

      <!-- 参数栏 -->
      <div class="c-title">{{params.name}}</div>
      <el-form size="mini" :inline="true" @submit.native.prevent >
        <el-form-item style="min-width: 0px;">
          <el-button type="danger" icon="el-icon-plus" @click="add()">重新生成课表（只能在没开课时使用）</el-button>
        </el-form-item>

        <el-form-item style="min-width: 0px;">
          <el-button type="primary" icon="el-icon-search" @click="f5()">查询</el-button>

        </el-form-item>
      </el-form>
      <b>{{getDesc()}}</b>
      <!-- 数据列表 -->
      <div class="c-title">[{{params.name}}] 课程列表</div>
      <el-table :data="dataList" size="mini">
        <el-table-column label="班级状态" width="80px">
          <template slot-scope="s">
            <el-tag class="c-tag" effect="dark" size="mini" color="#AEEEEE" v-if="s.row.status==0" @click="changeStatus(s.row.id,s.row.status)">未开始</el-tag>
            <el-tag class="c-tag" effect="dark" size="mini" color="#282" v-if="s.row.status!=0" @click="changeStatus(s.row.id,s.row.status)">已消课</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="上课时间" width="150px">
          <template slot-scope="s"><span>{{sa.forDate(s.row.time, 2)}}</span></template>
        </el-table-column>

        <el-table-column label="消耗课时" prop="hour" width="100px"></el-table-column>
        <el-table-column label="上课时长(分钟)" prop="length" width="100px"></el-table-column>
        <el-table-column label="上课老师" width="120px">
          <template slot-scope="s">
            <span style="color: #000000; ">{{getTeacherName(s.row.teaId)}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="创建日期" width="150px">-->
<!--          <template slot-scope="s"><span>{{sa.forDate3(s.row.createTime, 2)}}</span></template>-->
<!--        </el-table-column>-->
        <el-table-column label="上课内容" width="400px">
          <template slot-scope="s"><b>{{s.row.des}}</b></template>
        </el-table-column>

        <el-table-column label="操作" width="240px">
          <template slot-scope="s">
<!--            <el-button class="c-btn" type="success"  icon="el-icon-view" @click="openClazzCard(s.row)">课表</el-button>-->
            <el-button class="c-btn" type="primary" icon="el-icon-edit" @click="update(s.row)">修改</el-button>
            <el-button v-if="s.row.status!=0" class="c-btn" type="danger" icon="el-icon-edit" @click="absent(s.row)">缺课登记</el-button>
            <el-button v-if="s.row.status==0" class="c-btn" type="warning" icon="el-icon-message" @click="putoff(s.row)">顺延课程</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 增改组件 -->
    <add-or-update ref="add-or-update"></add-or-update>
    <add-or-remark ref="add-or-remark"></add-or-remark>
    <add-or-absent ref="add-or-absent"></add-or-absent>
  </div>
</template>

<script>
import addOrUpdate from '../clazzCard/clazz-card-list-add.vue';
import addOrRemark from '../clazzCard/clazz-card-list-remake.vue';
import addOrAbsent from '../clazzCard/clazz-card-list-absent.vue';
export default {
  props: ['params'],
  components: {
    addOrUpdate,addOrRemark,addOrAbsent
  },

  data() {
    return {

      p: {		// 查询参数
      },
      dataList: [],		// 数据集合
      teacherList:[], //老师列表
    }
  },
  methods: {
    // 刷新
    f5: function(){
      let data = {
        id:this.params.id
      }
      this.sa.ajax('api/psdAdmin/clazzCard/getList',
          data,
          function(res){
            if(res.code == 0) {
              this.dataList = res.data;	// 数据
              console.log('课表',res.data);
            }else{
              this.dataList=[];
              this.sa.error(res.msg || '会员列表获取失败');
            }
          }.bind(this)/*, {res: mockDataList}*/);
    },
    // 添加
    add: function () {
      this.$refs['add-or-remark'].open(this.params.id);
    },
    // 修改
    update: function (data) {
      this.$refs['add-or-update'].open(data.id);
    },
    // 缺课登记
    absent: function (data) {
      this.$refs['add-or-absent'].open(data.id);
    },
    putoff:function (data){
      let _this = this;
      this.sa.confirm("确定要对课程进行顺延吗？",function (){
        _this.sa.ajax('api/psdAdmin/clazzCard/putOffClazzCard',
            {id:data.id},
            function(res){
              if(res.code=='0'){
                _this.sa.alert("已顺延",function (){
                  _this.f5();
                });
              }else{
                _this.sa.error('顺延失败'+res.msg);
              }
            }.bind(this));
      });
    },
    changeStatus:function (id,status){
      let _this = this;
      if(status == 0){
        this.sa.confirm("确定完成该课程吗",function (){
          console.log("禁用");
          _this.sa.ajax('api/psdAdmin/clazzCard/changeClazzCardStatus',
              {id:id,status:'1'},
              function(res){
                if(res.code=='0'){
                  _this.sa.alert("已消课",function (){
                    _this.f5();
                  });
                }else{
                  _this.sa.error("消课失败");
                }
              }.bind(this));
        });
      }else{
        this.sa.confirm("确定变更为未上课吗",function (){
          _this.sa.ajax('api/psdAdmin/clazzCard/changeClazzCardStatus',
              {id:id,status:'0'},
              function(res){
                if(res.code=='0'){
                  _this.sa.alert("已变更",function (){
                    _this.f5();
                  });

                }else{
                  _this.sa.error("变更失败");
                }
              }.bind(this));
        });
      }
    },
    getTeacherList:function (){
      this.sa.ajax('api/psdAdmin/teacher/getList',
          {},
          function(res){
            this.teacherList = res.data;
            console.log('老师',res.data);
          }.bind(this),{async:false});
    },
    getTeacherName:function (id){
      for(let i=0;i<this.teacherList.length;i++){
        if(this.teacherList[i].id == id){
          return this.teacherList[i].name;
        }
      }
      return id;
    },
    getDesc:function (){
      let count=0;
      for(let i=0;i<this.dataList.length;i++){
        if(this.dataList[i].status>0){
          count++;
        }
      }
      return '总计'+this.dataList.length+'节课，已经消课'+count+'节';
    }


  },
  created: function(){
    this.getTeacherList();
    this.f5();
  },
  filters: {

  }
}
</script>
